import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import "flatpickr/dist/flatpickr.css";
import { FormattedMessage, useIntl } from "react-intl";
import Loader from "components/shared/Loader";
import { editSection, getSection } from "store/actions";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import ImagesUpload from "components/shared/ImagesUpload";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { v4 } from "uuid";

const Clients = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);
  const [slider, setSlider] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();
  // effects
  useEffect(() => {
    dispatch(
      getSection({
        page: "home-1",
        slug: "clients",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset(section);
    let images = [];
    section?.images?.forEach((imagePath) => {
      console.log(imagePath);
      const image = {
        id: v4(),
        preview: imagePath,
        path: imagePath,
      };
      images.push(image);
    });

    setSlider(images);
  }, [section, reset]);
  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);
  const onSubmit = (data) => {
    data.images = slider.map((image) => {
      return image.path;
    });
    dispatch(
      editSection({ slug: "clients", page: "home-1", data: { section: data } })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"clients"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg={12} xs={12}>
                  <div className="form-group ">
                    <h5>
                      <FormattedMessage id={"images"} />
                    </h5>
                    <ImagesUpload
                      imagesURLs={slider}
                      setImageURLs={setSlider}
                    />
                  </div>
                </Col>
              </Row>
              <SaveChangesButton />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Clients;
